import type React from 'react'
import { createContext, useContext, useState } from 'react'

interface IPayloadData {
  reservationNumber: any
  observation?: any
  type?: any
}

interface RequestCancelEditContextData {
  toggleRequestCancelEditModal: () => void
  setData: (payload: IPayloadData) => void
  payloadData: any | undefined
  isOpen: boolean
}

// eslint-disable-next-line
const RequestCancelEditContext = createContext<RequestCancelEditContextData>(
  {} as RequestCancelEditContextData,
)

function RequestCancelEditProvider({
  children,
}: React.PropsWithChildren<object>): JSX.Element {
  const [isOpen, setIsOpen] = useState(false)
  const [payloadData, setPayloadData] = useState<IPayloadData>()

  function toggle(): void {
    setIsOpen(!isOpen)
  }

  function setData(data: any): void {
    setPayloadData(data)
    toggle()
  }

  return (
    <RequestCancelEditContext.Provider
      value={{
        isOpen,
        toggleRequestCancelEditModal: toggle,
        payloadData,
        setData,
      }}
    >
      {children}
    </RequestCancelEditContext.Provider>
  )
}

function useRequestCancelEdit(): RequestCancelEditContextData {
  const context = useContext(RequestCancelEditContext)

  if (!context) {
    throw new Error(
      'useRequestCancelEdit must be used within an RequestCancelEditProvider',
    )
  }

  return context
}

export { RequestCancelEditProvider, useRequestCancelEdit }
